module.exports = "data:audio/mpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJtZWRpYS9tdXNjbGUtcmVsYXhhdGlvbi1hZHVsdC1sb25nLm1wMyI7"